module.exports = __webpack_public_path__ + "img/bottom_section.a918fe7.png";